module.exports = __webpack_public_path__ + "media/assets/teamsRightHeader-c2f7c8f3e7cb46808d2b8f22c09882f5.png";